var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.75 6c0-1.26-.5-2.468-1.391-3.359s-2.099-1.391-3.359-1.391h-12c-1.26 0-2.468.5-3.359 1.391s-1.391 2.099-1.391 3.359v12c0 1.26.5 2.468 1.391 3.359s2.099 1.391 3.359 1.391h12c1.26 0 2.468-.5 3.359-1.391s1.391-2.099 1.391-3.359zm-10.262 2.163-2.4 7.2c-.13.393.082.818.475.949.393.13.818-.082.949-.475l2.4-7.2c.13-.393-.082-.818-.475-.949-.393-.13-.818.082-.949.475zm2.582 1.967 1.869 1.87s-1.869 1.87-1.869 1.87c-.293.292-.293.768 0 1.06.292.293.768.293 1.06 0l2.4-2.4c.293-.293.293-.767 0-1.06l-2.4-2.4c-.292-.293-.768-.293-1.06 0-.293.292-.293.768 0 1.06zm-7.2-1.06-2.4 2.4c-.293.293-.293.767 0 1.06l2.4 2.4c.292.293.768.293 1.06 0 .293-.292.293-.768 0-1.06l-1.869-1.87s1.869-1.87 1.869-1.87c.293-.292.293-.768 0-1.06-.292-.293-.768-.293-1.06 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.306b40c658c3af70df5f578ae3d5ea23.svg";
export { ForwardRef as ReactComponent };